import { Type } from '@angular/core';

export class AdvancedFilterItem {
  constructor(
    public component: Type<any>,
    public data: any,
    public availableFilters?: any
  ) {}
}
